var render = function render(){
  var _vm$estimatedDti, _vm$estimatedDti2, _vm$estimatedDti2$ext, _vm$income;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header-block"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Orientačný limit úveru podľa DTI")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti = _vm.estimatedDti) === null || _vm$estimatedDti === void 0 ? void 0 : _vm$estimatedDti.value)) + " EUR")])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Akceptovaný príjem / mes.")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti2 = _vm.estimatedDti) === null || _vm$estimatedDti2 === void 0 ? void 0 : (_vm$estimatedDti2$ext = _vm$estimatedDti2.extra) === null || _vm$estimatedDti2$ext === void 0 ? void 0 : _vm$estimatedDti2$ext.prijem_mo)) + " EUR")])], 1)]), (_vm$income = _vm.income) !== null && _vm$income !== void 0 && _vm$income.error ? _c('div', [_c('br'), _vm._l(_vm.income.error, function (error, key) {
    return _c('div', {
      key: key,
      staticClass: "error-text"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  })], 2) : _vm._e()]), _c('form', {
    attrs: {
      "id": "income-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveIncome.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "w-tab-pane w--tab-active",
    attrs: {
      "data-w-tab": "Tab 1"
    }
  }, [_c('div', {
    staticClass: "w-form"
  }, [_vm._m(0), _c('monthly-amount-input', {
    attrs: {
      "averages": _vm.monthlyAmountAveragesFromInput,
      "init-months": _vm.form.monthlyIncomes
    },
    on: {
      "refresh-dti": _vm.showEstimatedDtiToUser
    }
  }), _c('div', {
    staticClass: "average-income-grid"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "priemer-inc-6"
    }
  }, [_vm._v(" Rýchlo vyplniť priemerom za 6 mesiacov ")]), _c('input', {
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "name": "priemer-inc-6",
      "data-name": "priemer-inc-6",
      "id": "priemer-inc-6"
    },
    on: {
      "change": function change($event) {
        return _vm.calculateAverage($event, 6);
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "priemer-inc-12"
    }
  }, [_vm._v(" Rýchlo vyplniť priemerom za 12 mesiacov ")]), _c('input', {
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "number",
      "maxlength": "256",
      "name": "priemer-inc-12",
      "data-name": "priemer-inc-12",
      "id": "priemer-inc-12"
    },
    on: {
      "change": function change($event) {
        return _vm.calculateAverage($event, 12);
      }
    }
  })])]), _vm._m(1), _c('div', {
    staticClass: "dropdown-input-custom required"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.druh,
      expression: "form.druh"
    }],
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "text",
      "required": _vm.required
    },
    domProps: {
      "value": _vm.form.druh
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "druh", $event.target.value);
      }
    }
  }), _c('dropdown-select', {
    attrs: {
      "id": 'employment_druh',
      "init-value": _vm.form.druh,
      "options": _vm.typeOfEmploymentSelect,
      "normal": "",
      "name": 'Typ pracovného pomeru'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'druh');
      }
    }
  })], 1), _vm.requiresEmploymentDuration ? _c('div', {
    staticClass: "duration-mode-switch",
    attrs: {
      "role": "tablist",
      "aria-label": "Spôsob zadania začiatku zamestnania"
    }
  }, [_c('button', {
    staticClass: "duration-mode-button",
    "class": {
      active: _vm.form.durationMode === 'quick'
    },
    attrs: {
      "type": "button",
      "aria-selected": _vm.form.durationMode === 'quick'
    },
    on: {
      "click": function click($event) {
        return _vm.setDurationMode('quick');
      }
    }
  }, [_vm._v(" Rýchly prepočet ")]), _c('button', {
    staticClass: "duration-mode-button",
    "class": {
      active: _vm.form.durationMode === 'exact'
    },
    attrs: {
      "type": "button",
      "aria-selected": _vm.form.durationMode === 'exact'
    },
    on: {
      "click": function click($event) {
        return _vm.setDurationMode('exact');
      }
    }
  }, [_vm._v(" Presný dátum ")])]) : _vm._e(), _vm.requiresEmploymentDuration && _vm.form.durationMode === 'quick' ? _c('div', {
    staticClass: "duration-options"
  }, [_vm._l(_vm.employmentDurationOptions, function (option) {
    return _c('button', {
      key: option.value,
      staticClass: "duration-option",
      "class": {
        active: _vm.form.durationCategory === option.value
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.setDurationCategory(option.value);
        }
      }
    }, [_c('span', {
      staticClass: "duration-option-title"
    }, [_vm._v(_vm._s(option.label))]), _c('span', {
      staticClass: "duration-option-description"
    }, [_vm._v(_vm._s(option.description))])]);
  }), _c('div', {
    staticClass: "duration-hint"
  }, [_vm._v(" Výpočet v rozmedzí 3 až 6 mesiacov je nastavený konzervatívne. Banky, ktoré vyžadujú dlhšiu históriu, sa sprístupnia po zadaní presného dátumu. ")])], 2) : _vm._e(), _vm.requiresEmploymentDuration && _vm.form.durationMode === 'exact' ? _c('div', {
    staticClass: "date-picker-wrapper"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.zamestnanyOd,
      expression: "form.zamestnanyOd"
    }],
    staticClass: "text-input w-input date-input required",
    attrs: {
      "type": "date",
      "max": _vm.getTodayDate(),
      "maxlength": "256",
      "name": "zamestnanyOd",
      "data-name": "Zamestnaný od",
      "id": "Zamestnan-od",
      "required": _vm.required
    },
    domProps: {
      "value": _vm.form.zamestnanyOd
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "zamestnanyOd", $event.target.value);
      }
    }
  })])]) : _vm._e(), _vm.isFixedTerm ? _c('div', {
    staticClass: "date-picker-wrapper single-date"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.form.zamestnanyDo,
      expression: "form.zamestnanyDo"
    }],
    staticClass: "text-input w-input date-input required",
    attrs: {
      "type": "date",
      "min": _vm.getTodayDate(),
      "maxlength": "256",
      "name": "zamestnanyDo",
      "data-name": "Zamestnaný do",
      "id": "Zamestnan-do",
      "required": _vm.required
    },
    domProps: {
      "value": _vm.form.zamestnanyDo
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "zamestnanyDo", $event.target.value);
      }
    }
  })])]) : _vm._e(), _vm.shortIncome ? _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'dovod_kratsej_doby_prijmu',
      "init-value": _vm.form.dovodKratsejDobyPrijmu,
      "options": _vm.formTemplate.dovod_kratsej_doby_prijmu.choices,
      "normal": "",
      "name": 'Dôvod kratšej doby príjmu'
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'dovodKratsejDobyPrijmu');
      }
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "text-input w-input date-input popup-input-wrapper"
  }, [_c('div', {
    staticClass: "blc-color"
  }, [_vm._v("Iné špecifiká príjmu")]), _c('client-employment-rest-handler', {
    attrs: {
      "rules": ['single'],
      "ostatne": _vm.restMultiselect
    }
  })], 1), _c('div', {
    staticClass: "employment-flow-heading"
  }, [_c('span', {
    staticClass: "employment-flow-number"
  }, [_vm._v("03")]), _c('div', [_c('div', {
    staticClass: "employment-flow-title"
  }, [_vm._v("Zamestnávateľ (nepovinné)")]), _c('div', {
    staticClass: "employment-flow-description"
  }, [_vm._v(" Úver môžete vypočítať aj bez IČO a názvu zamestnávateľa. Údaje môžete doplniť neskôr. ")]), !_vm.isForeignIncome ? _c('div', {
    staticClass: "employment-flow-description"
  }, [_vm._v(" IČO automaticky doplní obchodný názov a sídlo. Údaje môžete overiť na "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "https://www.finstat.sk/",
      "target": "_blank"
    }
  }, [_vm._v("finstat.sk")])]) : _vm._e()])]), _vm.isForeignIncome ? _c('div', {
    staticClass: "dropdown-input-custom required foreign-country-field"
  }, [_c('input', {
    staticStyle: {
      "opacity": "0",
      "position": "absolute"
    },
    attrs: {
      "type": "text",
      "required": "",
      "tabindex": "-1"
    },
    domProps: {
      "value": _vm.form.country
    }
  }), _c('dropdown-select', {
    attrs: {
      "id": 'employment_country',
      "init-value": _vm.form.country,
      "options": _vm.formTemplate.address_country.choices,
      "normal": "",
      "required": "",
      "name": 'Krajina zamestnania'
    },
    on: {
      "select": _vm.setEmploymentCountry
    }
  }), _c('div', {
    staticClass: "employment-flow-description foreign-income-hint"
  }, [_vm._v(" Krajina a mena rozhodujú o tom, ktoré banky príjem akceptujú. ")])], 1) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [!_vm.restMultiselect[4].value ? _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Typ-pr-jmu-2"
    }
  }, [_vm._v(" IČO "), _c('span', {
    staticClass: "pop-300"
  }, [_vm._v("(nepovinné, údaje sa doplnia automaticky)")])]) : _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Typ-pr-jmu-2"
    }
  }, [_vm._v(" ID spoločnosti "), _c('span', {
    staticClass: "pop-300"
  }, [_vm._v("(nepovinné)")])]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.ico,
      expression: "ico"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "readonly": !_vm.sidloInputNeed,
      "type": "text",
      "maxlength": _vm.isForeignIncome ? 64 : 8,
      "minlength": _vm.isForeignIncome ? null : 8,
      "name": "icoZamestnavatel",
      "data-name": "Typ Pr Jmu 2",
      "placeholder": "",
      "id": "Typ-pr-jmu-2"
    },
    domProps: {
      "value": _vm.ico
    },
    on: {
      "change": _vm.initializeEmployer,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.ico = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.employerDetail.name,
      expression: "employerDetail.name"
    }],
    staticClass: "text-input w-input",
    "class": {
      'input-color-disabled': !_vm.isForeignIncome
    },
    attrs: {
      "readonly": !_vm.isForeignIncome || !_vm.sidloInputNeed,
      "type": "text",
      "maxlength": "256",
      "name": "obchodny-nazov",
      "data-name": "obchodny-nazov",
      "placeholder": "",
      "id": "obchodny-nazov"
    },
    domProps: {
      "value": _vm.employerDetail.name
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.employerDetail, "name", $event.target.value);
      }
    }
  })]), _vm.isForeignIncome ? _c('div', [_vm.sidloInputNeed ? _c('sidlo-input', {
    attrs: {
      "type": 'house'
    },
    on: {
      "address-change": function addressChange($event) {
        return _vm.setAddress($event);
      }
    }
  }) : _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Sídlo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.sidloInputFormattedValue,
      expression: "sidloInputFormattedValue"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "readonly": "",
      "type": "text",
      "maxlength": "256",
      "name": "sidlo",
      "data-name": "sidlo",
      "placeholder": "",
      "id": "sidlo"
    },
    domProps: {
      "value": _vm.sidloInputFormattedValue
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.sidloInputFormattedValue = $event.target.value;
      }
    }
  })])], 1) : _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Sídlo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.employerDetail.slovensko_digital_response.formatted_address,
      expression: "\n                employerDetail.slovensko_digital_response.formatted_address\n              "
    }],
    staticClass: "text-input w-input",
    "class": {
      'input-color-disabled': !_vm.restMultiselect[4].value
    },
    attrs: {
      "readonly": !_vm.restMultiselect[4].value,
      "type": "text",
      "maxlength": "256",
      "name": "sidlo",
      "data-name": "sidlo",
      "placeholder": "",
      "id": "sidlo"
    },
    domProps: {
      "value": _vm.employerDetail.slovensko_digital_response.formatted_address
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.employerDetail.slovensko_digital_response, "formatted_address", $event.target.value);
      }
    }
  })])], 1)])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "employment-flow-heading"
  }, [_c('span', {
    staticClass: "employment-flow-number"
  }, [_vm._v("01")]), _c('div', [_c('div', {
    staticClass: "employment-flow-title"
  }, [_vm._v("Mesačný príjem")]), _c('div', {
    staticClass: "employment-flow-description"
  }, [_vm._v(" Zadajte posledné mesiace alebo použite rýchle vyplnenie priemerom. ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "employment-flow-heading"
  }, [_c('span', {
    staticClass: "employment-flow-number"
  }, [_vm._v("02")]), _c('div', [_c('div', {
    staticClass: "employment-flow-title"
  }, [_vm._v("Pracovný pomer")]), _c('div', {
    staticClass: "employment-flow-description"
  }, [_vm._v(" Na prvý prepočet stačí približná dĺžka zamestnania. Presný dátum môžete doplniť neskôr. ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Zamestnan-od"
    }
  }, [_vm._v("Zamestnaný "), _c('strong', [_vm._v("od")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "Zamestnan-do"
    }
  }, [_vm._v("Zamestnaný "), _c('strong', [_vm._v("do")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "obchodny-nazov"
    }
  }, [_vm._v("Obchodný názov "), _c('span', {
    staticClass: "pop-300"
  }, [_vm._v("(nepovinné)")])]);

}]

export { render, staticRenderFns }